<template>
    <Breadcrumbs
        main="Liste des réseaux sociaux"
        mains="Liste des réseaux sociaux"
        title="Publication"
    />
    <div class="container-fluid">
        <div class="row">
            <SocialNetworkList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const SocialNetworkList = defineAsyncComponent(
    () => import('@/components/theme/socialnetwork/SocialNetworkList.vue'),
);
</script>